/* 中文 */
export const Chinese: any = {
  language_code: "zh",
  get_btn: "立即领取",
  unregistered_tip: "未注册的用户将直接创建账户",
  phone_number: "手机号",
  ver_code: "验证码",
  get_ver_code: "取得验证码",
  retrieve_ver_code: "重新获取 ({SECONDS})",
  age_tip: "我已成年并具备完全民事行为能力，同意",
  and: "和",
  PRIVICY_POLICY: "《隐私政策》",
  MEMBER_AGGREMENT: "《会员须知》",
  agree_push: "本人同意以注册手机号或邮箱接收海底捞推送信息",
  CN: "中国",
  US: "美国",
  CA: "加拿大",
  GB: "英国",
  MY: "马来西亚",
  AU: "澳大利亚",
  ID: "印度尼西亚",
  SG: "新加坡",
  TH: "泰国",
  JP: "日本",
  KR: "韩国",
  VN: "越南",
  HK: "香港地区",
  MO: "澳门地区",
  HKM: "柬埔寨",
  TW: "台湾地区",
  PH: "菲律宾",
  UAE: "阿联酋",
  suc_send: "发送成功",
  suc_get: "领取成功",
  fail_ver_code: "验证码错误",
  time_end: "活动已结束",
  not_get_repeat: "无法重复领取！",
  not_get_eligible: "无法领取，不符合活动条件",
  not_get_late: "慢了一步，活动已经结束了",
  get_coupon: "领取优惠券",
  phone_err: "手机号错误，请输入正确的手机号",
  page_title: "领取海底捞专属优惠券",
  send_code_error: "发送验证码错误",
  network_error: "您当前的网络异常，请稍后再试",
  member_status_abnormal: "会员账号异常，无法领取",
  send_frequently: "验证码发送次数过多。请输入最后收到的验证码，或稍后再试。",
  activity_boom: "领取人数过多，请稍候再试",
  email: "邮箱",
  email_error_tip: "邮箱错误，请输入正确的邮箱",
  suc_get_dialog_text: "立即开启海底捞会员 APP，查看已领取的优惠券！",
  btn_sure: "确定",
  btn_cancel: "取消",
  suc_dialog_text: "开启海底捞APP或在LINE绑定会员，查看已领取的优惠券",
  btn_return: "返回",
  btn_download: "下载",
};
